import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker';

export default class RegCNoteBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      job: props.data || null,
      cNote:props.data.c_note || "",
      cOffhiredDate: props.data?.c_date ? new Date(props.data.c_date + 'T00:00:00') : null,
    };
  }
  handleCNoteChange(e){
    this.setState({cNote:e.target.value});
  }
  handleCOffhiredDateChange(date) {
     this.setState({ cOffhiredDate: date });
  }

  saveCNoteToJob(){
    this.setState({isLoading:true});
    let that = this;
    const d = that.state.cOffhiredDate;
    $.ajax({
      url: "/api/v1/portal/jobs/save-c-note/"+that.state.job.id,
      data: {
        api_token: window.api_token,
        c_note: that.state.cNote,
        c_date: d ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`: null
      },
      cache: false,
      method: 'post',
    })
    .done(function() {
      that.setState({isLoading:false});
      that.props.handleHideCNoteBox();
      that.props.handlehideCDateBox();
    });
    
  }
  render() {
    return (
    <div>
      {(this.state.job && this.state.job.id ?
        <div className="job-scheduler-modal c-note-block">
          <div className="job-scheduler-modal-body">
          <form id={'job-scheduler-note-for-job-'+this.state.job.id} className="text-left">
            <fieldset>
                <h1 className="text-right">Job #{this.state.job.id}</h1>
                <div className="row">
                    <div className="col-md-4 text-right">
                        <h2>Offhired Note: </h2>
                    </div>
                    <div className="col-md-4">
                        <textarea name="c_note"
                            placeholder={`Enter Offhired Note for job number ${this.state.job.id}`}
                            className="form-control form-control-lg"
                            defaultValue={this.state.job.c_note}
                            onChange={(e)=>this.handleCNoteChange(e)}>
                        </textarea> 
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-md-4 text-right">
                        <h2>Offhired Date: </h2>
                    </div>
                    <div className="col-md-4">
                        <DatePicker 
                            className="form-control form-control-lg"
                            todayButton={"Today"}
                            selected={this.state.cOffhiredDate}
                            dateFormat="dd/MM/yyyy"
                            onChange={(date)=>this.handleCOffhiredDateChange(date)} />
                    </div>
                </div>
                <div className="row">
                  <div className="col-md-5 text-right">
                    <br/>
                    <button className="btn btn-success btn-lg"
                    disabled={(this.state.isLoading) ? true : false}
                    onClick={(e)=>this.saveCNoteToJob(e)}
                    >Save Note</button>
                  </div>
                </div>
            </fieldset>
          </form>
        </div>
      </div> : null)}
    </div>
    );
  }
}
